import React from "react";
import GameMap from "./logic/GameMap";
import { mapConfigs } from "./MapConfig/mapConfigs";

export default function LowVisibility() {
  return <GameMap config={mapConfigs.lowvis} />;
}